import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as appPropTypes from '../../components/appPropTypes';
import { Appear } from '../../components/transitions';
import Peer from '../Peer';
import Me from '../Me';

const Peers = ({ peers, activeSpeakerId, amActiveSpeaker, type, isProvider, notCheckPermission }) => {
    console.log('peerspeers',peers);
    return (
        <div
            data-component="Peers"
            className={classnames(
                type,
                { provider: isProvider },
                { patient: !isProvider },
                {
                    four: peers.length >= 4,
                }
            )}
        >
            {peers
                .filter((item) => item.displayName.split('|')[3] === 'Provider')
                .map((peer) => {
                    return (
                        <Appear key={peer.id} duration={1000}>
                            <div
                                className={classnames('peer-container', {
                                    'active-speaker': peer.id === activeSpeakerId,
                                })}
                            >
                                <Peer notCheckPermission={notCheckPermission} id={peer.id} type={type} isProvider={isProvider} />
                            </div>
                        </Appear>
                    );
                })}

            <If
                condition={
                    (!isProvider && (type === 'group' || type === 'open')) ||
                    (isProvider && type === 'open')
                }
            >
                <div
                    className={classnames(
                        'me-container',
                        {
                            'active-speaker': amActiveSpeaker,
                        },
                        type,
                        { provider: isProvider },
                        { patient: !isProvider }
                    )}
                >
                    <Me isProvider={isProvider} notCheckPermission={notCheckPermission} type={type} />
                </div>
            </If>

            {peers
                .filter((item) => item.displayName.split('|')[3] !== 'Provider')
                .map((peer) => {
                    return (
                        <Appear key={peer.id} duration={1000}>
                            <div
                                className={classnames('peer-container', {
                                    'active-speaker': peer.id === activeSpeakerId,
                                })}
                            >
                                <Peer notCheckPermission={notCheckPermission} id={peer.id} type={type} isProvider={isProvider} />
                            </div>
                        </Appear>
                    );
                })}
        </div>
    );
};

Peers.propTypes = {
    peers: PropTypes.arrayOf(appPropTypes.Peer).isRequired,
    activeSpeakerId: PropTypes.string,
    amActiveSpeaker: PropTypes.bool,
    type: PropTypes.string,
    isProvider: PropTypes.bool,
    notCheckPermission: PropTypes.any,
};

const mapStateToProps = (state) => {
    const peersArray = Object.values(state.peers);

    return {
        peers: peersArray,
        activeSpeakerId: state.room.activeSpeakerId,
        amActiveSpeaker: state.me.id === state.room.activeSpeakerId,
    };
};

const PeersContainer = connect(mapStateToProps, null, null, {
    areStatesEqual: (next, prev) => {
        return prev.peers === next.peers && prev.room.activeSpeakerId === next.room.activeSpeakerId;
    },
})(Peers);

export default PeersContainer;
